import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import {MessageBox} from 'element-ui'
import router from '../router/index'
import user from '../store/user'
// import tagsView from '../store/tagsView'
import {showFullScreenLoading, hideFullScreenLoading} from './Loading'

const vue = new Vue()
// axios.defaults.headers.TOKEN_KEY = localStorage.getItem('token')

// 请求次数
let retry = 1
let loadingNum = 0
axios.interceptors.request.use(
  config => {
    let list = ['/api/saas/homePage/getWarehouseDistributionMap'] // 不需要显示loading
    // 获取token
    if (loadingNum === 0 && list.indexOf(config.url) === -1) {
      showFullScreenLoading('loadingtext')
    }
    loadingNum++
    return config
  },
  error => {
    console.log(error)
  }
)
/* 添加响应拦截器 */
axios.interceptors.response.use(function (response) {
  /* 对响应数据做些事 */
  loadingNum--
  if (loadingNum === 0) {
    hideFullScreenLoading()
  }
  return response
}, function (error) {
  loadingNum--
  if (loadingNum === 0) {
    hideFullScreenLoading()
  }
  /* 请求错误时做些事 */
  // 请求超时的之后，抛出 error.code = ECONNABORTED的错误..错误信息是 timeout of  xxx ms exceeded
  if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    var config = error.config
    config.__retryCount = config.__retryCount || 0

    if (config.__retryCount >= retry) {
      // console.log(config.__retryCount, 'config.__retryCount')
      // Reject with the error
      MessageBox.confirm('请求超时，是否重新加载？', '确认信息', {
        // distinguishCancelAndClose: true,
        confirmButtonText: '是'
        // cancelButtonText: '否'
      })
        .then(() => {
          localStorage.removeItem('token')
          window.location.reload()
        })
        .catch(action => {
          confirm.close()
        })

      return Promise.reject(error)
    }

    // Increase the retry count
    config.__retryCount += 1

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function (resolve) {
      setTimeout(function () {
        // console.log('resolve')
        resolve()
      }, config.retryDelay || 1)
    })

    return backoff.then(function () {
      return axios(config)
    })
  } else {
    return Promise.reject(error)
  }
})

export default {
  fetchNoMessage (path, params, contentType, closeErrMsg, responseType = {}) {
    if (!(params instanceof FormData)) {
      if (!contentType) {
        contentType = 'application/x-www-form-urlencoded'
        params = qs.stringify({
          // token作为参数
          TOKEN_KEY: localStorage.getItem('token'),
          ...params
        })
      }
    }
    return axios.post(path, params, {
      headers: {
        'Content-Type': contentType,
        'TOKEN_KEY': localStorage.getItem('token')
      },
      ...responseType
    }).then(function (req) {
      let data = req.data
      if (data.code && data.code !== 200 && !closeErrMsg) {
        if (data.code === 501) {
          // token已过期，跳转至登录页
          vue.$message({
            showClose: true,
            message: '登录时间过期或配置信息变更，请重新登录',
            type: 'error'
          })
          localStorage.removeItem('token')
          user.state.userinfo = {
            menuList: null
          }
          setTimeout(() => {
            setTimeout(() => {
              router.push('/login')
            }, 100)
            // tagsView.dispatch('tagsView/delAllViews')
          }, 3000)
          return false
        }
        return Promise.reject(data)
      }
      return data
    }).catch((err) => {
      return err
    })
  },
  fetch (path, params, contentType, closeErrMsg, responseType = {}) {
    if (!(params instanceof FormData)) {
      if (!contentType) {
        contentType = 'application/x-www-form-urlencoded'
        params = qs.stringify({
          // token作为参数
          TOKEN_KEY: localStorage.getItem('token'),
          ...params
        })
      }
    }
    return axios.post(path, params, {
      headers: {
        'Content-Type': contentType,
        'TOKEN_KEY': localStorage.getItem('token')
      },
      ...responseType
    }).then(function (req) {
      let data = req.data
      if (data.code && data.code !== 200 && !closeErrMsg) {
        if (data.code === 501) {
          // token已过期，跳转至登录页
          vue.$message({
            showClose: true,
            message: '登录时间过期或配置信息变更，请重新登录',
            type: 'error'
          })
          localStorage.removeItem('token')
          user.state.userinfo = {
            menuList: null
          }
          setTimeout(() => {
            setTimeout(() => {
              router.push('/login')
            }, 100)
            // tagsView.dispatch('tagsView/delAllViews')
          }, 3000)
          return false
        }
        vue.$message({
          showClose: true,
          message: data.message,
          type: 'error'
        })
        return Promise.reject(data)
      }
      return data
    }).catch((err) => {
      return err
    })
  },
  downloadFile (options) {
    const {
      url,
      params = {},
      data = {},
      method = 'GET',
      fileName = ''
    } = options

    // 配置axios请求
    const axiosConfig = {
      url,
      method,
      responseType: 'blob', // 关键：设置响应类型为blob
      params: method.toUpperCase() === 'GET' ? params : {},
      data: method.toUpperCase() === 'POST' ? data : {},
      headers: {'TOKEN_KEY': localStorage.getItem('token'),'Content-type': 'application/json, text/plain, */*'}
    }

    return new Promise((resolve, reject) => {
      axios(axiosConfig)
        .then(response => {

          const contentType = response.headers['content-type']
          if (contentType && contentType.includes('application/json')) {
            // 将blob转换为JSON错误信息
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result)
                const errorMessage = errorData.message || '文件下载失败'
                reject(new Error(errorMessage))
              } catch (e) {
                reject(new Error('无法解析服务器返回的错误信息'))
              }
            }
            reader.onerror = () => {
              reject(new Error('读取服务器响应失败'))
            }
            reader.readAsText(new Blob([response.data]))
            return
          }

          let downloadFileName = fileName
          const contentDisposition = response.headers['content-disposition']

          if (!downloadFileName && contentDisposition) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            const matches = filenameRegex.exec(contentDisposition)
            if (matches != null && matches[1]) {
              downloadFileName = matches[1].replace(/['"]/g, '')
              // 尝试解码URL编码的文件名
              try {
                downloadFileName = decodeURIComponent(downloadFileName)
              } catch (e) {
                // 解码失败，使用原始文件名
              }
            }
          }

          // 如果仍然没有文件名，使用默认名
          if (!downloadFileName) {
            downloadFileName = 'download'
            // 根据Content-Type确定文件扩展名
            if (contentType) {
              const extensions = {
                'application/pdf': '.pdf',
                'application/vnd.ms-excel': '.xls',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
                'application/msword': '.doc',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
                'application/zip': '.zip',
                'application/x-rar-compressed': '.rar',
                'image/jpeg': '.jpg',
                'image/png': '.png'
              }
              downloadFileName += extensions[contentType] || ''
            }
          }

          // 创建Blob对象
          const blob = new Blob([response.data], {
            type: contentType || 'application/octet-stream'
          })

          // 创建下载链接
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = downloadFileName

          // 触发下载
          document.body.appendChild(link)
          link.click()

          // 清理
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)

          resolve({success: true, fileName: downloadFileName})
        })
        .catch(error => {
          reject(new Error(`下载失败: ${error.message}`))
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js